import { Position } from "./../../interface/delivery";
import { BillDetail, Bill } from "../../interface/bill";
export class CreateDelivery {
  static readonly type = "[Delivery] Mutation CreateDelivery]";
}

export class GetBillsForDelivery {
  static readonly type = "[Delivery] Query GetBillsForDelivery]";
}

export class GetDeliveryByUser {
  static readonly type = "[Delivery] Query GetDeliveryByUser]";
}

export class UpdateDeliveryState {
  static readonly type = "[Delivery] Mutation UpdateDeliveryState]";
  constructor(public readonly id: number, public readonly state: number) {}
}

export class UpdateBillDetailState {
  static readonly type = "[Delivery] Mutation UpdateBillDetailState]";
  constructor(
    public readonly id: string,
    public readonly state: number,
    public readonly billId: string
  ) {}
}

export class UpdateNextPointOfDelivery {
  static readonly type = "[Delivery] Mutation UpdateNextPointOfDelivery]";
  constructor(
    public readonly id: number,
    public readonly FK_DeliveryState: number,
    public readonly FK_Address: number,
    public readonly TypeNextPoint_Delivery: number
  ) {}
}

export class FinishBillDelivery {
  static readonly type = "[Delivery] Mutation FinishBillDelivery]";
  constructor(public readonly id: number) {}
}

export class WatchPosition {
  static readonly type = "[Delivery] WatchPosition";
}

export class GetBills {
  static readonly type = "[BillsDelivery, bills: null] GetBills";
  constructor(public readonly position?: Position) {}
}

export class SetPosition {
  static readonly type = "[Delivery] SetPosition";
}

export class UpdateRadius {
  static readonly type = "[DeliveryParams] UpdateRadius";
  constructor(public readonly radius?: number) {}
}

export class SetBills {
  static readonly type = "[Delivery] SetBills]";
  constructor(public readonly bills: any[]) {}
}

export class SetWatchId {
  static readonly type = "[Delivery] SetWatchId]";
  constructor(public readonly watchId: number) {}
}

export class ClearWatchId {
  static readonly type = "[Delivery] ClearWatchId]";
}

export class RegisterDelivery {
  static readonly type = "[Delivery] RegisterDelivery]";
  constructor(
    public readonly billsIds: string[],
    public readonly FK_Address: string,
    public readonly token: string
  ) {}
}

export class ChangeBillDetailState {
  static readonly type = "[Delivery] ChangeBillDetailState]";
  constructor(
    public readonly detail: BillDetail,
    public readonly state: number
  ) {}
}

export class CalculateNextPoint {
  static readonly type = "[Delivery] CalculateNextPoint]";
}

export class DeliveryUserPosition {
  static readonly type = "[Delivery] DeliveryUserPosition]";
  constructor(public readonly position: Position) {}
}

export class GetUserForBillDelivery {
  static readonly type = "[Delivery] GetUserForBillDelivery";
  constructor(public readonly criteria) {}
}

export class UpdateDeliveryCoin {
  static readonly type = "[Delivery] UpdateDeliveryCoin]";
  constructor(public readonly coin) {}
}

export class UpdateBillAsNotDelivered {
  static readonly type = "[Delivery] Mutation UpdateBillAsNotDelivered]";
  constructor(
    public readonly id,
    public readonly Description_NotDeliveredBill
  ) {}
}

export class GetBillsDelivery {
  static readonly type = "[BillsDelivery] GetBillsDelivery";
  constructor(public readonly bills: Bill[]) {}
}

export class DeliveryNextPoint {
  static readonly type = "[Delivery] DeliveryNextPoint]";
  constructor(public readonly deliveryOrders: Bill[]) {}
}
